<template>
  <div
    class="lv-text"
    :class="{
      red: red,
      bold: bold,
      blue: blue,
      white: white,
      green: green,
      remark: remark,
      yellow: yellow,
      required: required,
      h1: h1,
      h2: h2,
      'h2-5': h2_5,
      h3: h3,
      'h3-5': h3_5,
      'h3-7': h3_7,
      h4: h4,
      h5: h5,
      h6: h6,
      'light-gray': lightGray,
      'ellipsis-2': isEllipsis2,
      'ellipsis-3': isEllipsis3,
      'remove-style': removeStyle,
      'justify-content-center': justifyCenter,
      'no-wrap': noWrap,
      wrap,
      'bg-yellow': bgYellow,
      'pre-wrap': preWrap,
      'min-width-0': minWidth0,
    }"
    :style="{ color: color, 'text-align': textAlign }"
    @click="$emit('click', $event)"
  >
    <slot />
  </div>
</template>
<script>
export default {
  props: {
    removeStyle: {
      type: Boolean,
      default: false,
    },
    isEllipsis2: {
      type: Boolean,
      default: false,
    },
    isEllipsis3: {
      type: Boolean,
      default: false,
    },
    bold: {
      type: Boolean,
      default: false,
    },
    h1: {
      type: Boolean,
      default: false,
    },
    h2: {
      type: Boolean,
      default: false,
    },
    h2_5: {
      type: Boolean,
      default: false,
    },
    h3: {
      type: Boolean,
      default: false,
    },
    h3_5: {
      type: Boolean,
      default: false,
    },
    h3_7: {
      type: Boolean,
      default: false,
    },
    h4: {
      type: Boolean,
      default: false,
    },
    h5: {
      type: Boolean,
      default: false,
    },
    h6: {
      type: Boolean,
      default: false,
    },
    remark: {
      type: Boolean,
      default: false,
    },
    lightGray: {
      type: Boolean,
      default: false,
    },
    required: {
      type: Boolean,
      default: false,
    },
    justifyCenter: {
      type: Boolean,
      default: false,
    },
    white: {
      type: Boolean,
      default: false,
    },
    blue: {
      type: Boolean,
      default: false,
    },
    red: {
      type: Boolean,
      default: false,
    },
    green: {
      type: Boolean,
      default: false,
    },
    yellow: {
      type: Boolean,
      default: false,
    },
    noWrap: {
      type: Boolean,
      default: false,
    },
    wrap: {
      type: Boolean,
      default: false,
    },
    color: {
      type: String,
    },
    textAlign: {
      type: String,
    },
    bgYellow: {
      type: Boolean,
      default: false,
    },
    preWrap: {
      type: Boolean,
      default: false,
    },
    /** flex 子項內文換行時，避免預設 min-width:auto 導致無法縮排 */
    minWidth0: {
      type: Boolean,
      default: false,
    },
  },
};
</script>
